import { connect } from 'react-redux';
import KelolaPembagianKlsKhusus from '../../../views/Akademi/DataKelas/KelolaPembagianKlsKhusus.view';
import { getClasses } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    classes: state.options.classes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KelolaPembagianKlsKhusus);
